import _ from "lodash";
import { generateElementName } from "../../KonvaCommonUtils";
import { IMAGE_ELEMENT_CONFIG } from "../KonvaConfig";

const imageCache = {};

/**
 *
 * @param {*} item
 * @param {*} konva
 * @returns New Image instance
 */
export const createImageNode = (item, { stage, layer, konva } = {}) => {
  const canDrag = _.isEqual(_.get(item, "category"), "DRAGGABLE");

  const answersMapping = stage.getAttr("answersMapping");
  const isDroppedIn = _.includes(
    _.flatten(_.values(answersMapping)),
    _.get(item, "id")
  );

  const props = {
    id: _.get(item, "id"),
    shadowBlur: IMAGE_ELEMENT_CONFIG.SHADOW_BLUR,
    shadowOffsetX: IMAGE_ELEMENT_CONFIG.SHADOW_OFFSETX,
    shadowOffsetY: IMAGE_ELEMENT_CONFIG.SHADOW_OFFSETY,
    x: _.get(item, "x"),
    y: _.get(item, "y"),
    cornerRadius: canDrag
      ? IMAGE_ELEMENT_CONFIG.DRAG_CORNER_RADIUS
      : IMAGE_ELEMENT_CONFIG.CORNER_RADIUS,
    name: generateElementName(item),
    width: _.get(item, "width", IMAGE_ELEMENT_CONFIG.DEFAULT_SIZE),
    height: _.get(item, "height", IMAGE_ELEMENT_CONFIG.DEFAULT_SIZE),
    draggable: _.get(item, "draggable", false),
    stroke: IMAGE_ELEMENT_CONFIG.STROKE_COLOR,
    strokeWidth: canDrag ? IMAGE_ELEMENT_CONFIG.STROKE_WIDTH : 0,
    shadowColor: canDrag ? IMAGE_ELEMENT_CONFIG.STROKE_COLOR : "rgba(0,0,0,0)",
  };

  if (isDroppedIn) props.shadowColor = "rgba(0,0,0,0)";

  const url = _.get(item, "url");

  if (_.has(imageCache, url)) {
    const node = new konva.Image({ ...props, image: _.get(imageCache, url) });
    layer.add(node);
    return node;
  }

  const node = new konva.Image({ ...props });
  layer.add(node);

  const imageObj = new Image();
  imageObj.src = url;
  imageObj.onload = function () {
    imageCache[url] = this;
    node.image(this);
  };

  return node;
};

/**
 *
 * @param {*} node
 * @param {*} konva
 * @returns is image node or not
 */
export const isImageNode = (node, konva) => {
  return node && node instanceof konva.Image;
};
